module.exports = __webpack_public_path__ + "img/electrique.d2e050e9.png";